import React, { useEffect, useState } from "react";
import { fetchAuctionProducts, submitBid, addToCart } from "../../api/api";
import AuctionProductCard from "../Auction/Auction";
import { motion } from "framer-motion";
import { slideIn, staggerChildren } from "../../utils/motion";
import "./AuctionList.css";

const AuctionList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);

  const loadProducts = async (p = page) => {
    setLoading(true);
    try {
      const data = await fetchAuctionProducts(p, pageSize);
      setProducts(data.products);
      setTotalPages(data.pagination.totalPages);
      setPage(p);
    } catch (err) {
      console.error("Failed to fetch:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleBid = async (productId, amount) => {
    const response = await submitBid(productId, amount);
    return response; // <-- return the response for use in the card
  };

  const handleAdd = async (productId) => {
    const response = await addToCart(productId);
    return response;
  };

  useEffect(() => {
    console.log("🔁 AuctionList mounted, loading products");
    loadProducts();
  }, []);

  return (
    <div>
      <h2 style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}>
        Auction Sales
      </h2>
      {loading ? (
        <div className="loading-spinner-wrapper">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <>
          <div className="auction-grid">
            {products.map((p) => (
              <div key={p._id}>
                <AuctionProductCard
                  product={p}
                  onBid={handleBid}
                  onAddToCart={handleAdd}
                  reloadProducts={loadProducts}
                />
              </div>
            ))}
          </div>
          <div style={{ marginTop: 20 }}>
            {/* Simple pagination buttons */}
            <button onClick={() => loadProducts(page - 1)} disabled={page <= 1}>
              Previous
            </button>
            <span>
              {" "}
              Page {page} of {totalPages}{" "}
            </span>
            <button
              onClick={() => loadProducts(page + 1)}
              disabled={page >= totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AuctionList;
